var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowing)?_c('div',{ref:"interactElement",staticClass:"card",class:( _obj = {
    isAnimating: _vm.isInteractAnimating,
    isCurrent: _vm.isCurrent
  }, _obj[_vm.card.id] = true, _obj ),style:({ transform: _vm.transformString })},[(_vm.card.id !== 'game')?_c('div',[_vm._l((_vm.card.sentences),function(sentence){return _c('p',{key:sentence,staticClass:"cardTitle"},[_vm._v(" "+_vm._s(sentence)+" ")])}),_c('button',{staticClass:"next",on:{"click":_vm.next}},[_vm._v(" Next ")])],2):_c('div',{staticClass:"game-container"},[_c('Board',{ref:"board",attrs:{"grid":_vm.grid}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }